var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckcontainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1703)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13H26C26.8281 13 27.5 13.6719 27.5 14.5V19.5C27.5 20.3281 26.8281 21 26 21H16.5C15.6719 21 15 20.3281 15 19.5V14.5C15 13.6719 15.6719 13 16.5 13ZM17.5 14.5C17.225 14.5 17 14.725 17 15V19C17 19.275 17.225 19.5 17.5 19.5C17.775 19.5 18 19.275 18 19V15C18 14.725 17.775 14.5 17.5 14.5ZM22 15V19C22 19.275 22.225 19.5 22.5 19.5C22.775 19.5 23 19.275 23 19V15C23 14.725 22.775 14.5 22.5 14.5C22.225 14.5 22 14.725 22 15ZM20 14.5C19.725 14.5 19.5 14.725 19.5 15V19C19.5 19.275 19.725 19.5 20 19.5C20.275 19.5 20.5 19.275 20.5 19V15C20.5 14.725 20.275 14.5 20 14.5ZM24.5 15V19C24.5 19.275 24.725 19.5 25 19.5C25.275 19.5 25.5 19.275 25.5 19V15C25.5 14.725 25.275 14.5 25 14.5C24.725 14.5 24.5 14.725 24.5 15ZM28.5 17.25C28.5 16.8344 28.8344 16.5 29.25 16.5H31.525C32.05 16.5 32.5469 16.7344 32.8781 17.1406L34.7188 19.3875C34.9 19.6094 35 19.8906 35 20.1781V20.5V21V23C35 23.5531 34.5531 24 34 24H33.95C33.9813 24.1625 34 24.3281 34 24.5C34 25.8813 32.8813 27 31.5 27C30.1187 27 29 25.8813 29 24.5C29 24.3281 29.0188 24.1625 29.05 24H28.5H23.95C23.9812 24.1625 24 24.3281 24 24.5C24 25.8813 22.8813 27 21.5 27C20.6812 27 19.9563 26.6062 19.5 26C19.0437 26.6062 18.3188 27 17.5 27C16.1187 27 15 25.8813 15 24.5V24V23C15 22.4469 15.4469 22 16 22H17.5H21.5H28.5V21V20V17.25ZM30 20H33.2812L31.7188 18.0906C31.6719 18.0312 31.6 18 31.525 18H30V20ZM32.5 24.5C32.5 23.9469 32.0531 23.5 31.5 23.5C30.9469 23.5 30.5 23.9469 30.5 24.5C30.5 25.0531 30.9469 25.5 31.5 25.5C32.0531 25.5 32.5 25.0531 32.5 24.5ZM21.5 25.5C22.0531 25.5 22.5 25.0531 22.5 24.5C22.5 23.9469 22.0531 23.5 21.5 23.5C20.9469 23.5 20.5 23.9469 20.5 24.5C20.5 25.0531 20.9469 25.5 21.5 25.5ZM18.5 24.5C18.5 23.9469 18.0531 23.5 17.5 23.5C16.9469 23.5 16.5 23.9469 16.5 24.5C16.5 25.0531 16.9469 25.5 17.5 25.5C18.0531 25.5 18.5 25.0531 18.5 24.5Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1703",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1703"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckcontainer);
export default __webpack_public_path__ + "static/media/truckcontainer.3519ebbe447fb1b89944de169ac51563.svg";
export { ForwardRef as ReactComponent };